import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import SettingSidebar from "../components/Setttingsidebar";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../App.css";
import { ApiUrl } from '../Constants/Weburl'
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import CustomPagination from "../components/Custompagination";
import CustomContainer from '../components/Customsettingscontain';
import CustomTable from '../components/CustomTable';
import CustomButton from "../components/CustomButton";
import CustomInput from '../components/Custominput';
import DeleteModal from "../components/DeleteModal";
import Layout from "../components/Layout";
import useExpandableRows from "../components/useExpandableRows";
import useHiddenColumns from "../components/useHiddenFields";

// export default function Hashtags() {

//     const [allhashtag, setAllhashtag] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [pageSize, setPageSize] = useState(10);
//     const [totalPages, setTotalPages] = useState(1);
//     const [searchText, setSearchText] = useState("");
//     const [inputValue, setInputValue] = useState(""); // For input field display


//     //add hashtag state
//     const [hashtags, setHashtags] = useState([]);
//     const [newHashtag, setNewHashtag] = useState("");
//     const [editingId, setEditingId] = useState(null);
//     const [editingText, setEditingText] = useState("");

//     //add modal 
//     const [showModal, setShowModal] = useState(false);

//     //save model
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [editId, setEditId] = useState(null);
//     const [editTag, setEditTag] = useState("");

//      const navigate = useNavigate();
//     const location = useLocation();
//     // let params = { useParams };
//     //all hashtag get api
//     const fetchHashtags = async (page = 1) => {
//         try {
//             const res = await axios.get(`${ApiUrl}api/search`, {
//                 params: {
//                     page,
//                     limit: pageSize,
//                     search: searchText
//                 }
//             });

//             console.log("hashtag search", res.data)

//             setAllhashtag(res.data.data);
//             setCurrentPage(page);
//             setTotalPages(res.data.totalPages);

//         } catch (e) {
//             console.log("fetchHashtags error", e);
//         }
//     };



//     useEffect(() => {
//         fetchHashtags(1);
//     }, [pageSize, searchText]);


//     //add hashtag api 
//     // const addHashtag = async () => {
//     //     let tag = window.prompt("Enter hashtag (example: #funny)");
//     //     if (!tag) return;
//     //     //  tag = newHashtag.trim();

//     //     if (!tag.startsWith("#")) tag = `#${tag}`;
//     //     if (tag.length > 11) {
//     //         alert("Hashtag must be 10 letters or less");
//     //         return;
//     //     }

//     //     try {
//     //         const res = await axios.post(
//     //             `${ApiUrl}api/hashtags`,
//     //             { name: tag }
//     //         );

//     //         console.log("res hashtagadd", res.data.data)

//     //         setHashtags(prev => [res.data.data, ...prev]);
//     //         setNewHashtag("");

//     //     } catch (err) {
//     //         console.error("Add hashtag error", err);
//     //     }
//     // };

//     const addHashtag = async () => {

//         let tag = newHashtag.trim();

//         if (!tag) return;

//         if (!tag.startsWith("#")) {
//             tag = "#" + tag;
//         }

//         if (tag.length > 11) {
//             alert("Hashtag must be 10 letters or less");
//             return;
//         }

//         try {

//             const res = await axios.post(
//                 `${ApiUrl}api/hashtags`,
//                 { name: tag }
//             );

//             setAllhashtag(prev => [res.data.data, ...prev]);

//             setNewHashtag("");

//             setShowModal(false);

//         } catch (err) {
//             console.log(err);
//         }
//     };


//     //edit hashtag api
//     // const saveEdit = async (id, oldTag) => {
//     //     let tag = window.prompt("Edit hashtag", oldTag);

//     //     if (!tag) return; // cancel pressed

//     //     tag = tag.trim();

//     //     if (!tag.startsWith("#")) {
//     //         tag = `#${tag}`;
//     //     }

//     //     if (tag.length > 11) {
//     //         alert("Hashtag must be 10 letters or less");
//     //         return;
//     //     }

//     //     try {
//     //         const res = await axios.put(
//     //             `${ApiUrl}api/edithashtags/${id}`,
//     //             { name: tag }
//     //         );

//     //         console.log("edit hashtag", res.data.data);

//     //         setHashtags(prev =>
//     //             prev.map(h => (h.id === id ? res.data.data : h))
//     //         );

//     //     } catch (err) {
//     //         console.error("Edit error", err);
//     //         alert("Failed to update hashtag");
//     //     }
//     // };

//     const saveEdit = async () => {

//         let tag = editTag.trim();

//         if (!tag.startsWith("#")) {
//             tag = "#" + tag;
//         }

//         if (tag.length > 11) {
//             alert("Hashtag must be 10 letters or less");
//             return;
//         }

//         try {

//             const res = await axios.put(
//                 `${ApiUrl}api/edithashtags/${editId}`,
//                 { name: tag }
//             );

//             setAllhashtag(prev =>
//                 prev.map(item =>
//                     item.id === editId ? res.data.data : item
//                 )
//             );

//             setShowEditModal(false);

//         } catch (err) {
//             console.log(err);
//         }
//     };

//     //delete hashtag api
//     const deleteHashtag = async (id) => {
//         if (!window.confirm("Delete this hashtag?")) return;

//         try {
//             const res = await axios.delete(
//                 `${ApiUrl}api/deletehashtags/${id}`
//             );

//             console.log("res deleteHashtag", res.data);

//             setAllhashtag(prev => prev.filter(h => h.id !== id));

//         } catch (err) {
//             console.error("Delete error", err);
//             alert("Failed to delete hashtag");
//         }
//     };

//     return (
//         <div className="layout">
//             <Sidebar />
//             <main className="content">
//                 <Topbar />


//                 <CustomContainer className="rr-wrapperhashtag" fluid="false">
//                     <div className="rr-top-headerhashtag">
//                         <h3>Hashtags</h3>
//                         <CustomButton className="rr-add-btnhashtag" 
//                             variant='#e2f0ef'
//                             // onClick={addHashtag}
//                             onClick={() => setShowModal(true)}
//                         >
//                             Add Hashtag
//                         </CustomButton>
//                     </div>

//                     <div className="rr-card">
//                         <div className="rr-controls">
//                             <div className="rr-left">
//                                 Show
//                                 <select
//                                     className="rr-select"
//                                     value={pageSize}
//                                     onChange={(e) => setPageSize(Number(e.target.value))}>
//                                     <option>5</option>
//                                     <option>10</option>
//                                     <option>25</option>
//                                     <option>50</option>
//                                 </select>
//                                 entries
//                             </div>

//                             <div className="rr-right">
//                                 <span>Search:</span>
//                                 <CustomInput
//                                     className="rr-search"
//                                     type="text"
//                                     value={searchText}
//                                     onChange={(e) => setSearchText(e.target.value)}
//                                     placeholder="Search hashtag"
//                                 />
//                             </div>
//                         </div>

//                         <CustomTable
//                             className="rr1-table"
//                             headers={[
//                                 { label: "Hashtags", className: 'rr-actions1' },
//                                 { label: "Post Count", className: 'rr-actions1' },
//                                 { label: "Action", className: 'rr-actions' },
//                             ]}
//                         >
//                             {/* <thead className="rr1-tablehashtag">
//                                 <tr>
//                                     <th className="rr-actions1">Hashtag</th>
//                                     <th className="rr-actions2">Post Count</th>
//                                     <th className="rr-actions">Action</th>
//                                 </tr>
//                             </thead> */}

//                             {/* <tbody > */}
//                                 {allhashtag.map((item, idx) => (
//                                     <tr className="rr-actionshastag" key={idx} >
//                                         {/* <td className="rr-actions1">{item.hashtag}</td> */}
//                                         <td className="rr-actions1">
//                                             {/* <a href="/Hashtagdetails" target="_blank" className="hashtagahref">
//                                                 <h3 className="h3hashtag">{item.tag}</h3>
//                                             </a> */}
//                                             <Link
//                                                 to={`/Hashtagdetails/${item.tag.replace("#", "")}`}
//                                                 target="_blank"
//                                                 className="hashtagahref"
//                                             >
//                                                 <h5 className="h3hashtag">
//                                                     {item.tag}
//                                                 </h5>
//                                             </Link>

//                                         </td>
//                                         <td className="rr-actions2">{item.posts}</td>
//                                         <td className="rr-actions">
//                                             <CustomButton
//                                                 className="rr-icon-btn green"
//                                                 // onClick={() => saveEdit(item.id, item.tag)}
//                                                 onClick={() => {
//                                                     setEditId(item.id);
//                                                     setEditTag(item.tag);
//                                                     setShowEditModal(true);
//                                                 }}
//                                             >
//                                                 <i className="bi bi-pencil"></i>
//                                             </CustomButton>

//                                             <CustomButton
//                                                 className="rr-icon-btn red"
//                                                 onClick={() => deleteHashtag(item.id, item.tag)}
//                                             >
//                                                 <i className="bi bi-trash"></i>
//                                             </CustomButton>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             {/* </tbody> */}
//                         </CustomTable>

//                         <div className="rr-footer">
//                             <span>
//                                 Showing 1 to {allhashtag.length} of {allhashtag.length} entries
//                             </span>


//                             {/* <div className="rr-pagination">
//                                 <span
//                                     className="rr-page-arrow"
//                                     onClick={() => currentPage > 1 && fetchHashtags(currentPage - 1)}
//                                 >
//                                     &lt;
//                                 </span>

//                                 {[...Array(totalPages)].map((_, index) => {
//                                     const page = index + 1;
//                                     return (
//                                         <span
//                                             key={page}
//                                             className={`rr-page ${currentPage === page ? "active" : ""}`}
//                                             onClick={() => fetchHashtags(page)}
//                                         >
//                                             {page}
//                                         </span>
//                                     );
//                                 })}

//                                 <span
//                                     className="rr-page-arrow"
//                                     onClick={() =>
//                                         currentPage < totalPages && fetchHashtags(currentPage + 1)
//                                     }
//                                 >
//                                     &gt;
//                                 </span>
//                             </div> */}
//                                 <CustomPagination
//                                 currentPage={currentPage}
//                                 totalPages={totalPages}
//                                 onPageChange={(page) => fetchHashtags(page)}
//                                 className="rr-pagination"
//                                 pageClassName="rr-page"
//                                 activeClassName="active"
//                                 ellipsisClassName="rr-page"
//                             />

//                         </div>
//                     </div>
//                 </CustomContainer>

//             </main>

//             <Modal
//                 show={showModal}
//                 onHide={() => setShowModal(false)}
//                 centered
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add Hashtag</Modal.Title>
//                 </Modal.Header>

//                 <Modal.Body>

//                     <Form.Control
//                         type="text"
//                         placeholder="Enter hashtag"
//                         value={newHashtag}
//                         onChange={(e) => setNewHashtag(e.target.value)}
//                     />

//                 </Modal.Body>

//                 <Modal.Footer>

//                     <Button
//                         variant="secondary"
//                         onClick={() => setShowModal(false)}
//                     >
//                         Cancel
//                     </Button>

//                     <Button
//                         variant="primary"
//                         onClick={addHashtag}
//                     >
//                         Add
//                     </Button>

//                 </Modal.Footer>

//             </Modal>

//             <Modal
//                 show={showEditModal}
//                 onHide={() => setShowEditModal(false)}
//                 centered
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Edit Hashtag</Modal.Title>
//                 </Modal.Header>

//                 <Modal.Body>

//                     <Form.Control
//                         value={editTag}
//                         onChange={(e) => setEditTag(e.target.value)}
//                     />

//                 </Modal.Body>

//                 <Modal.Footer>

//                     <Button
//                         variant="secondary"
//                         onClick={() => setShowEditModal(false)}
//                     >
//                         Cancel
//                     </Button>

//                     <Button
//                         variant="primary"
//                         onClick={saveEdit}
//                     >
//                         Save
//                     </Button>

//                 </Modal.Footer>

//             </Modal>
//         </div>
//     );
// }

export default function Hashtags() {

    const [allhashtag, setAllhashtag] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [inputValue, setInputValue] = useState("");

    const [hashtags, setHashtags] = useState([]);
    const [newHashtag, setNewHashtag] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [editingText, setEditingText] = useState("");

    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editId, setEditId] = useState(null);
    const [editTag, setEditTag] = useState("");

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteTag, setDeleteTag] = useState("");


    const navigate = useNavigate();
    const location = useLocation();

    const { toggleExpand, isExpanded } = useExpandableRows();

    // const headers = [
    //     { label: "Hashtag", className: 'ht-col-name' },
    //     { label: "Post Count", className: 'ht-col-count' },
    //     { label: "Action", className: 'ht-col-action' },
    // ]
    const headers = [
    { label: "Hashtag", className: 'ht-col-name', field: "ht-name" },
    { label: "Post Count", className: 'ht-col-count', field: "ht-count" },
    { label: "Action", className: 'ht-col-action', field: "ht-action" },
]


    const hiddenFields = useHiddenColumns(".rr1-table", headers);

    // Read search from URL on component mount
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const searchParam = params.get('search');
        if (searchParam) {
            console.log("Search term from URL:", searchParam);
            setSearchText(searchParam); // For API filtering
            // Do NOT set inputValue - keep it empty
        }
    }, []);

    // Update search when URL changes
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const searchParam = params.get('search');
        if (searchParam && searchParam !== searchText) {
            console.log("Search term updated from URL:", searchParam);
            setSearchText(searchParam);
            setCurrentPage(1);
            // Do NOT set inputValue - keep it empty
        }
    }, [location.search]);

    //all hashtag get api
    const fetchHashtags = async (page = 1) => {
        try {
            const res = await axios.get(`${ApiUrl}api/search`, {
                params: {
                    page,
                    limit: pageSize,
                    search: searchText
                }
            });

            console.log("hashtag search", res.data)

            setAllhashtag(res.data.data);
            setCurrentPage(page);
            setTotalPages(res.data.totalPages);

        } catch (e) {
            console.log("fetchHashtags error", e);
        }
    };

    useEffect(() => {
        fetchHashtags(1);
    }, [pageSize, searchText]);

    //add hashtag api 
    const addHashtag = async () => {

        let tag = newHashtag.trim();

        if (!tag) return;

        if (!tag.startsWith("#")) {
            tag = "#" + tag;
        }

        if (tag.length > 11) {
            alert("Hashtag must be 10 letters or less");
            return;
        }

        try {

            const res = await axios.post(
                `${ApiUrl}api/hashtags`,
                { name: tag }
            );

            setAllhashtag(prev => [res.data.data, ...prev]);

            setNewHashtag("");

            setShowModal(false);

        } catch (err) {
            console.log(err);
        }
    };

    //edit hashtag api
    const saveEdit = async () => {

        let tag = editTag.trim();

        if (!tag.startsWith("#")) {
            tag = "#" + tag;
        }

        if (tag.length > 11) {
            alert("Hashtag must be 10 letters or less");
            return;
        }

        try {

            const res = await axios.put(
                `${ApiUrl}api/edithashtags/${editId}`,
                { name: tag }
            );

            setAllhashtag(prev =>
                prev.map(item =>
                    item.id === editId ? res.data.data : item
                )
            );

            setShowEditModal(false);

        } catch (err) {
            console.log(err);
        }
    };

    //delete hashtag api
    const deleteHashtag = async (id) => {
        // if (!window.confirm("Delete this hashtag?")) return;

        try {
            const res = await axios.delete(
                `${ApiUrl}api/deletehashtags/${id}`
            );

            console.log("res deleteHashtag", res.data);

            setAllhashtag(prev => prev.filter(h => h.id !== id));

            if (res.data.success) {

                setShowDeleteModal(false);
                setDeleteId(null);
            }
            else {
                alert("Delete Failed")
            }

        } catch (err) {
            console.error("Delete error", err);
            alert("Failed to delete hashtag");
        }
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        setSearchText(value);
        setCurrentPage(1);

        const params = new URLSearchParams(location.search);
        if (value) {
            params.set('search', value);
        } else {
            params.delete('search');
        }
        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    return (
        <div className="layout">
            <Layout>

                <CustomContainer className="rr-wrapperhashtag" fluid="false">
                    {/* ── Header bar: [Hashtags]  [Add Hashtag(center)]  [Show entries  Search] ── */}
                    <div className="ht-header-bar">

                        {/* Left: title */}
                        <h3 className="ht-page-title">Hashtags</h3>

                        {/* Center: Add Hashtag button — absolutely centered */}
                        <CustomButton
                            className="rr-add-btnhashtag ht-add-btn"
                            variant='#e2f0ef'
                            onClick={() => setShowModal(true)}
                        >
                            Add Hashtag
                        </CustomButton>

                        {/* Right: Show entries + Search */}
                        <div className="ht-header-right">
                            <div className="rr-left">
                                Show
                                <select
                                    className="rr-select"
                                    value={pageSize}
                                    onChange={(e) => setPageSize(Number(e.target.value))}>
                                    <option>5</option>
                                    <option>10</option>
                                    <option>25</option>
                                    <option>50</option>
                                </select>
                                entries
                            </div>
                            <div className="rr-right">
                                <span>Search:</span>
                                <CustomInput
                                    className="rr-search"
                                    type="text"
                                    value={inputValue}
                                    onChange={handleSearchChange}
                                    placeholder="Search hashtag"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="rr-card">

                        <CustomTable
                            className="rr1-table hashtag-table" headers={headers}
                        >
                            {allhashtag.map((item, idx) => (
                                <React.Fragment key={item.id ?? idx}>
                                    <tr className="rr-actionshastag">
                                        <td className="ht-col-name">
                                            {hiddenFields.length > 0 && (
                                                <button
                                                    type="button"
                                                    className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""
                                                        }`}
                                                    onClick={() => toggleExpand(item.id ?? idx)}
                                                    aria-label="Show more details"
                                                >
                                                    {isExpanded(item.id ?? idx) ? "−" : "+"}
                                                </button>
                                            )}
                                            <Link
                                                to={`/Hashtagdetails/${item.tag.replace("#", "")}`}
                                                target="_blank"
                                                className="hashtagahref"
                                            >
                                                <h5 className="h3hashtag">{item.tag}</h5>
                                            </Link>
                                            {/* Stacked action buttons — only ≤480px */}
                                            <div className="ht-stacked-meta">
                                                <div className="ht-stacked-actions">
                                                    <CustomButton
                                                        className="rr-icon-btn green"
                                                        onClick={() => {
                                                            setEditId(item.id);
                                                            setEditTag(item.tag);
                                                            setShowEditModal(true);
                                                        }}
                                                    >
                                                        <i className="bi bi-pencil"></i>
                                                    </CustomButton>
                                                    <CustomButton
                                                        className="rr-icon-btn red"
                                                        onClick={() => {
                                                            setDeleteId(item.id);
                                                            setDeleteTag(item.tag);
                                                            setShowDeleteModal(true);
                                                        }}
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                    </CustomButton>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="ht-col-count">
                                            <span className="rr-actions2">{item.posts}</span>
                                        </td>
                                        <td className="ht-col-action rr-actions">
                                            <CustomButton
                                                className="rr-icon-btn green"
                                                onClick={() => {
                                                    setEditId(item.id);
                                                    setEditTag(item.tag);
                                                    setShowEditModal(true);
                                                }}
                                            >
                                                <i className="bi bi-pencil"></i>
                                            </CustomButton>
                                            <CustomButton
                                                className="rr-icon-btn red"
                                                onClick={() => {
                                                    setDeleteId(item.id);
                                                    setDeleteTag(item.tag);
                                                    setShowDeleteModal(true);
                                                }}
                                            >
                                                <i className="bi bi-trash"></i>
                                            </CustomButton>
                                        </td>
                                    </tr>

                                     {isExpanded(item.id ?? idx) && hiddenFields.length > 0 && (
      <tr className="row-expand-details">

        <td colSpan={3}>

          <div className="expand-details">

            {hiddenFields.map(({ field, label }) => (
              <div className="expand-item" key={field}>

                <span className="expand-label">
                  {label}
                </span>

                {/* Hashtag */}
                {field === "ht-name" && (
                  <span className="expand-value">
                    {item.tag}
                  </span>
                )}

                {/* Post Count */}
                {field === "ht-count" && (
                  <span className="expand-value">
                    {item.posts}
                  </span>
                )}

                {/* Action */}
                {field === "ht-action" && (
                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                    }}
                  >
                    <CustomButton
                      className="rr-icon-btn green"
                      onClick={() => {
                        setEditId(item.id);
                        setEditTag(item.tag);
                        setShowEditModal(true);
                      }}
                    >
                      <i className="bi bi-pencil"></i>
                    </CustomButton>

                    <CustomButton
                      className="rr-icon-btn red"
                      onClick={() => {
                        setDeleteId(item.id);
                        setDeleteTag(item.tag);
                        setShowDeleteModal(true);
                      }}
                    >
                      <i className="bi bi-trash"></i>
                    </CustomButton>
                  </div>
                )}

              </div>
            ))}

          </div>

        </td>

      </tr>
    )}
                                </React.Fragment>
                            ))}
                        </CustomTable>

                        <div className="rr-footer">
                            <span>
                                Showing 1 to {allhashtag.length} of {allhashtag.length} entries
                            </span>

                            <CustomPagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={(page) => fetchHashtags(page)}
                                className="rr-pagination"
                                pageClassName="rr-page"
                                activeClassName="active"
                                ellipsisClassName="rr-page"
                            />
                        </div>
                    </div>
                </CustomContainer>


            </Layout>
            {/* Add Hashtag Modal */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                className="hashtag-add-modal"
            >
                <Modal.Header className="hashtag-modal-header">
                    <Modal.Title>Add Hashtag</Modal.Title>

                    <CustomButton
                        type="button"
                        className="hashtag-close-btn"
                        onClick={() => setShowModal(false)}
                    >
                        ×
                    </CustomButton>
                </Modal.Header>

                <Modal.Body className="hashtag-modal-body">

                    <div className="profile-pill">
                        Hashtag
                    </div>

                    <div className="hashtag-input-wrapper">

                        <div className="hashtag-symbol">
                            #
                        </div>

                        <Form.Control
                            type="text"
                            placeholder="Enter hashtag"
                            value={newHashtag}
                            important
                            onChange={(e) => setNewHashtag(e.target.value)}
                        />
                    </div>
                </Modal.Body>

                <Modal.Footer className="hashtag-modal-footer">
                    <CustomButton
                        className="hashtag-close-footer-btn"
                        variant="secondary"
                        onClick={() => setShowModal(false)}
                    >
                        Close
                    </CustomButton>
                    <CustomButton
                        className="hashtag-save-btn"
                        variant="primary"
                        onClick={addHashtag}
                    >
                        Save
                    </CustomButton>
                </Modal.Footer>
            </Modal>

            {/* Edit Hashtag Modal */}
            <Modal
                show={showEditModal}
                onHide={() => setShowEditModal(false)}
                centered
                className="hashtag-add-modal"
            >
                <Modal.Header className="hashtag-modal-header">
                    <Modal.Title>Edit Hashtag</Modal.Title>

                    <button
                        type="button"
                        className="hashtag-close-btn"
                        onClick={() => setShowEditModal(false)}
                    >
                        ×
                    </button>
                </Modal.Header>

                <Modal.Body className="hashtag-modal-body">
                    <Form.Control
                        value={editTag}
                        onChange={(e) => setEditTag(e.target.value)}
                    />
                </Modal.Body>

                <Modal.Footer className="hashtag-modal-footer">
                    <CustomButton
                        variant="secondary"
                        onClick={() => setShowEditModal(false)}
                        className="hashtag-close-footer-btn"
                    >
                        Cancel
                    </CustomButton>
                    <CustomButton
                        className="hashtag-save-btn"
                        variant="primary"
                        onClick={saveEdit}
                    >
                        Save
                    </CustomButton>
                </Modal.Footer>
            </Modal>


            <DeleteModal
                show={showDeleteModal}
                close={() => {
                    setShowDeleteModal(false);
                    setDeleteId(null);
                    setDeleteTag("");
                }}
                onDelete={() => deleteHashtag(deleteId)}
                title="Delete Hashtag"
                message="Are you sure you want to delete this Hashtag?"
                itemName={`${deleteTag}`}
            />

        </div>
    );
}

